import React from "react";
import { AuthContext } from "../Context/AuthContext";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {
  const { isAuth } = React.useContext(AuthContext);

  if (!isAuth) {
    return (
      alert("You have to login first"),
      <Navigate to="/"/>
    );
  }

  return children;
}

export { PrivateRoute };